import { discussionItems } from "@/mocks/home";

export default function DiscussionFeed() {
  return (
    <section id="discuss" className="scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr]">
          {/* 左：导语 + 实时状态 */}
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600">
              <i className="ri-chat-smile-2-line"></i>
              正在聊
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              满屏都是活人，等你来搭话
            </h2>
            <p className="mt-3 text-base leading-relaxed text-foreground-600">
              这里的每条讨论都来自真实的追瓜搭子，语气轻松、观点多元。
              看到感兴趣的帖子，欢迎参与进来，把你想说的都聊开。
            </p>

            <div className="mt-7 flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-100/60 p-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-leaf-line text-xl"></i>
              </span>
              <div>
                <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                  <span className="relative flex h-2 w-2">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary-400 opacity-75"></span>
                    <span className="relative inline-flex h-2 w-2 rounded-full bg-secondary-500"></span>
                  </span>
                  3.2 万网友在线
                </p>
                <p className="mt-0.5 text-xs text-foreground-500">每分钟都有新帖与新回复刷新</p>
              </div>
            </div>
          </div>

          {/* 右：讨论列表 */}
          <div className="flex flex-col gap-3">
            {discussionItems.map((d) => (
              <article
                key={d.id}
                className="flex items-start gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-background-300 md:p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100 text-base font-semibold text-primary-700">
                  {d.avatar}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-3">
                    <p className="whitespace-nowrap text-sm font-medium text-foreground-700">
                      {d.author}
                    </p>
                    <span className="whitespace-nowrap text-xs text-foreground-400">{d.time}</span>
                  </div>
                  <a
                    href="#guide"
                    className="mt-1 block text-base font-semibold text-foreground-950 hover:text-primary-700"
                  >
                    {d.title}
                  </a>
                  <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                    {d.preview}
                  </p>
                  <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-1-line"></i>
                      {d.replies} 条回复
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-thumb-up-line"></i>
                      赞
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-share-forward-line"></i>
                      分享
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}